import { ButtonVariant, CoButton } from "components/CoButton";
import PaperAccessButton, {
  PaperAccessButtonType,
} from "components/DetailContent/PaperAccessButton";
import { ShareDropdown } from "components/ShareDropdown";
import { PaperDetails } from "helpers/api";
import useLabels from "hooks/useLabels";

type PaperActionButtonsProps = {
  handleClickCite?: () => void;
  handleClickSave?: (paperId: string) => void;
  handleClickShare?: () => void;
  isBookmarked?: boolean;
  isOutOfFreeBookmarkItems?: boolean;
  paper?: PaperDetails;
  hideCite?: boolean; // TODO(Aakash): Remove this once the feature flag is removed
  hideShare?: boolean; // TODO(Aakash): Remove this once the feature flag is removed
  paperAccessButtonType?: PaperAccessButtonType;
};

function PaperActionButtons({
  handleClickCite,
  handleClickSave,
  handleClickShare,
  isBookmarked,
  isOutOfFreeBookmarkItems,
  paper,
  hideCite,
  hideShare,
  paperAccessButtonType,
}: PaperActionButtonsProps) {
  const [shareLabels, detailPageLabels] = useLabels("share", "screens.details");

  const onSaveClick =
    handleClickSave && paper ? () => handleClickSave(paper.id) : undefined;

  return (
    <div className="flex justify-between">
      <div className="flex flex-1 overflow-y-auto">
        {!paperAccessButtonType ? (
          <CoButton
            icon={isBookmarked ? "icon-bookmark-solid" : "icon-bookmark"}
            label={
              isBookmarked
                ? detailPageLabels["saved"]
                : detailPageLabels["save"]
            }
            onClick={onSaveClick}
            size="sm"
            variant={ButtonVariant.Tertiary}
            className="mr-4"
            disabled={!paper}
          />
        ) : (
          <PaperAccessButton
            type={paperAccessButtonType}
            uploaded_paper_id={paper?.id}
          />
        )}
        {!hideCite && (
          <CoButton
            hideLabelResponsively
            icon="icon-quote"
            label={detailPageLabels["cite"]}
            onClick={handleClickCite}
            size="sm"
            variant={ButtonVariant.Flat}
            disabled={!paper || !handleClickCite}
          />
        )}
        {!hideShare && (
          <ShareDropdown
            title={shareLabels["share-paper"]}
            description={shareLabels["share-paper-details-description"]}
            keyTakeaway={paper?.abstract_takeaway}
          >
            <CoButton
              data-testid="share-detail"
              hideLabelResponsively
              icon="icon-link"
              label={shareLabels["share"]}
              onClick={handleClickShare}
              size="sm"
              variant={ButtonVariant.Flat}
              disabled={!paper || !handleClickShare}
            />
          </ShareDropdown>
        )}
      </div>
    </div>
  );
}

export default PaperActionButtons;
